import React from 'react';
import PropTypes from 'prop-types';

import { Edit03Icon } from '@metarouter-private/mr-mui';

import PipelineSchemaLibraryModal from './shared/PipelineSchemaLibraryModal';

const MODAL_CONFIG = {
  title: 'Edit Schema Library',
  helperText:
    'Select a Schema Library, specify its version and start tracking event schema violations for your Pipeline. This will be deployed',
  TitleIcon: Edit03Icon,
  submitLabel: 'Save Changes',
};

export default function EditPipelineSchemaLibraryModal({ open, onClose, id, schemaLibraryId, schemaLibraryVersionId }) {
  const modalProps = {
    open,
    onClose,
    pipelineSchemaLibraryId: id,
    schemaLibraryId,
    schemaLibraryVersionId,
    ...MODAL_CONFIG,
  };

  return <PipelineSchemaLibraryModal {...modalProps} />;
}

EditPipelineSchemaLibraryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  schemaLibraryId: PropTypes.string.isRequired,
  schemaLibraryVersionId: PropTypes.string.isRequired,
};
